module.exports = __webpack_public_path__ + "media/images/editicon-4187809c.png";